import React, { Component } from "react";
import { can } from "../../utils/permission";
import {
  company,
  loading,
  NavbarAdmin,
  Modal,
  Select,
  DatePicker,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  format_date,
  activeOptions,
} from "../../components/CustomComponent.js";
import ActivityModal from "../../components/ActivityModal.js";

/**
 * ตั้งค่าปฏิทิน (เดิม "ปฏิทินวันหยุด")
 * - วันหยุดบริษัท = ค่า default ที่รายงานทุกตัวใช้ (สีเทา)
 * - วันหยุดรายช่าง = ช่างหยุดสลับกันได้ (ไม่ล็อกการมอบหมายงาน ใช้ประกอบการออกรายงานเท่านั้น) (สีแดง)
 * - วันหยุดประจำสัปดาห์ (ทั้งบริษัท / รายช่าง) ระบบขยายเป็นวันจริงให้ตอนออกรายงาน
 * - กิจกรรมล่วงหน้าของช่างเทคนิค (สี teal) - ไม่ล็อกการมอบหมายงาน มอบหมายได้หลายช่างต่อ 1 กิจกรรม
 * มุมมอง: ปฏิทิน / ตารางรายช่าง
 * API: admin/holidays, admin/holidays/effective, admin/holidays/toggle, admin/holiday-types, admin/activities, admin/objectives
 */

const WEEKDAY_KEYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
const HOLIDAY_TYPES = ["public", "company", "personal"];
const VIEWS = ["calendar", "matrix"];
// ขนาดคงที่ของช่องวันในปฏิทิน (แก้บั๊ก CSS Grid overflow ที่ยืดตามเนื้อหา)
const CAL_CELL_HEIGHT = 132;
// จำนวนรายการ (วันหยุดช่าง + กิจกรรม รวมกัน) สูงสุดที่โชว์ในช่องก่อนยุบเป็น "+N"
const MAX_CAL_EXTRA_ITEMS = 2;

const pad = (n) => String(n).padStart(2, "0");
const toDateStr = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;
const daysInMonth = (y, m) => new Date(y, m, 0).getDate();
const currentLang = () => ((localStorage.getItem("lang") || "TH") === "EN" ? "en" : "th");
const todayStr = () => {
  const d = new Date();
  return toDateStr(d.getFullYear(), d.getMonth() + 1, d.getDate());
};
// ขยายช่วงวันที่เป็นรายวัน (ใช้ตอนเพิ่มวันหยุดหลายวันติดกัน)
const expandRange = (start, end) => {
  const out = [];
  const cursor = new Date(`${start}T00:00:00`);
  const last = new Date(`${(end || start)}T00:00:00`);
  while (cursor <= last && out.length < 400) {
    out.push(toDateStr(cursor.getFullYear(), cursor.getMonth() + 1, cursor.getDate()));
    cursor.setDate(cursor.getDate() + 1);
  }
  return out;
};

export default class Holidays extends Component {
  constructor(props) {
    super(props);
    const now = new Date();
    this.state = {
      view: "calendar",
      year: now.getFullYear(),
      month: now.getMonth() + 1,

      filter_technician: "",

      // วันหยุดที่มีผลจริงในเดือนที่เลือก (ปฏิทิน / ตารางรายช่าง)
      effective: null,
      data_technicians: [],
      // ช่างที่มีผู้ใช้ปัจจุบันเป็นผู้บังคับบัญชา (ใช้กับตัวกรอง "ลูกน้องของฉัน")
      data_technicians_mine: [],
      data_holiday_types_company: [],
      data_holiday_types_employee: [],
      data_objectives: [],
      data_activities: [],

      modal_create: false,
      modal_update: false,
      // modal รายละเอียดทั้งวัน (เปิดจาก +N ในปฏิทิน)
      modal_day: false,
      day_date: "",

      uid: "",
      scope: "company",
      technician_uid: "",
      holiday_date: "",
      holiday_end_date: "",
      name: "",
      holiday_type: "company",
      // master "ประเภทวันหยุด" (holiday_types) ที่ผู้ใช้ตั้งเอง - แยกชุดตามขอบเขต company/employee
      holiday_type_id: "",
      note: "",

      // ---------- "+ เพิ่มกิจกรรม" ----------
      // รายละเอียดฟอร์มอยู่ใน components/ActivityModal.js - หน้านี้เก็บแค่ว่าเปิดอยู่ไหมและเปิดด้วยค่าอะไร
      activity_modal_open: false,
      activity_modal_activity: null,
      activity_modal_date: "",
      activity_modal_technician_uid: "",

      // ---------- ตัวกรองช่างของตารางรายช่าง (ช่างทั้งหมด / เลือกรายคน) ----------
      matrix_filter_mode: "all",
      matrix_filter_custom: [],
      matrix_filter_picker_open: false,
      matrix_filter_search: "",

      // ข้อความ toast ด้านล่างจอ (คลิก tag ในปฏิทินเพื่ออ่านข้อความเต็ม)
      toast_message: "",
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get();
  }

  Get = async () => {
    loading(true);
    const [resTechnicians, resTechniciansMine, resTypesCompany, resTypesEmployee, resObjectives] = await Promise.all([
      GET("admin/technicians", { page: 0, page_size: 10000 }),
      // "ลูกน้องของฉัน" ในตัวกรองตารางรายช่าง - ไม่มีลูกน้อง = data [] ไม่ error
      GET("admin/technicians", { supervisor: "me", page: 0, page_size: 10000 }),
      GET("admin/holiday-types", { scope: "company" }),
      GET("admin/holiday-types", { scope: "employee" }),
      GET("admin/objectives", { usage_type: "technician", page: 0, page_size: 10000 }),
      this.refreshEffective(),
      this.refreshActivities(),
    ]);
    if (resTechnicians?.status) this.setState({ data_technicians: resTechnicians.data || [] });
    if (resTechniciansMine?.status) this.setState({ data_technicians_mine: resTechniciansMine.data || [] });
    if (resTypesCompany?.status) this.setState({ data_holiday_types_company: resTypesCompany.data || [] });
    if (resTypesEmployee?.status) this.setState({ data_holiday_types_employee: resTypesEmployee.data || [] });
    if (resObjectives?.status) this.setState({ data_objectives: resObjectives.data || [] });
    loading(false);
  };

  // โหลดวันหยุดที่มีผลจริงของเดือนที่เลือก (หลังกดสลับช่องในตารางรายช่างเรียกตัวนี้โดยไม่ขึ้น overlay)
  refreshEffective = async () => {
    const { year, month } = this.state;
    const res = await GET("admin/holidays/effective", { year, month });
    if (res?.status && res.data) this.setState({ effective: res.data });
  };

  // โหลดกิจกรรมของเดือนที่เลือก (ไม่มี activity.read ก็ยังใช้หน้าได้ปกติ แค่ไม่เห็นกิจกรรม)
  refreshActivities = async () => {
    const { year, month } = this.state;
    const res = await GET("admin/activities", {
      start_date: toDateStr(year, month, 1),
      end_date: toDateStr(year, month, daysInMonth(year, month)),
      page: 0,
    });
    this.setState({ data_activities: res?.status && Array.isArray(res.data) ? res.data : [] });
  };

  // ชื่อช่างรูปแบบเดียวกับช่อง "ช่างที่โทร" ใน Fast Call: ชื่อ นามสกุล (ชื่อเล่น) ไทยก่อน ไม่มีค่อยใช้อังกฤษ
  getTechnicianDisplayName = (technician) => {
    const nicknameTh = technician?.nickname_th ? ` (${technician.nickname_th})` : "";
    const nicknameEn = technician?.nickname_en ? ` (${technician.nickname_en})` : "";
    return (
      [technician?.first_name_th, technician?.last_name_th, nicknameTh].filter(Boolean).join(" ") ||
      [technician?.first_name_en, technician?.last_name_en, nicknameEn].filter(Boolean).join(" ") ||
      "-"
    );
  };

  // ตัวเลือกช่าง (ซ่อนช่างที่ปิดใช้งาน เว้นแต่เป็นตัวที่เลือกอยู่) ใช้ร่วมกันทั้งตัวกรองและ modal
  technicianOptions = (current) =>
    activeOptions(
      (this.state.data_technicians || []).map((technician) => ({
        is_active: technician.is_active,
        value: technician.uid,
        label: this.getTechnicianDisplayName(technician),
      })),
      current,
    );

  // ตัวกรองช่างของปฏิทิน: ไม่เลือก = แสดงทุกคน, มีปุ่มล้างค่าเพราะ Select ไม่มี clear ในตัว
  renderTechnicianFilter() {
    const { filter_technician } = this.state;
    return (
      <div className="d-flex align-items-center gap-1">
        <div className="wpx-250">
          <Select
            className="form-control"
            placeholder={t("select_technician")}
            options={this.technicianOptions(filter_technician)}
            value={filter_technician}
            onChange={(value) => this.setState({ filter_technician: value })}
          />
        </div>
        {filter_technician && (
          <button
            className="btn btn-white border rounded-3 px-2 py-2 text-secondary"
            title={t("clear_all")}
            onClick={() => this.setState({ filter_technician: "" })}
          >
            <span className="icon">{""}</span>
          </button>
        )}
      </div>
    );
  }

  // ตัวกรองช่างของตารางรายช่าง: ช่างทั้งหมด / เลือกรายคน (คุมว่าแถวไหนแสดงในตาราง)
  renderMatrixFilter() {
    const { matrix_filter_mode, matrix_filter_custom, matrix_filter_picker_open, matrix_filter_search, data_technicians } = this.state;
    const filtered = (data_technicians || []).filter(
      (tc) => !matrix_filter_search || this.getTechnicianDisplayName(tc).toLowerCase().includes(matrix_filter_search.toLowerCase()),
    );
    return (
      <div className="d-flex flex-wrap gap-2 position-relative">
        <button
          type="button"
          className={`btn rounded-3 px-3 py-2 text-14 ${matrix_filter_mode === "all" ? "bg-primary-light text-primary border border-primary fw-bold" : "btn-white border text-secondary"}`}
          onClick={() => this.setState({ matrix_filter_mode: "all", matrix_filter_picker_open: false })}
        >
          {t("hd_filter_all")}
        </button>
        <button
          type="button"
          className={`btn rounded-3 px-3 py-2 text-14 ${matrix_filter_mode === "mine" ? "bg-primary-light text-primary border border-primary fw-bold" : "btn-white border text-secondary"}`}
          onClick={() => this.setState({ matrix_filter_mode: "mine", matrix_filter_picker_open: false })}
        >
          {t("hd_filter_mine")}
        </button>
        <button
          type="button"
          className={`btn rounded-3 px-3 py-2 text-14 ${matrix_filter_mode === "custom" ? "bg-primary-light text-primary border border-primary fw-bold" : "btn-white border text-secondary"}`}
          onClick={() => this.setState({ matrix_filter_picker_open: !matrix_filter_picker_open })}
        >
          {t("hd_filter_custom")}{matrix_filter_custom.length > 0 ? ` (${matrix_filter_custom.length})` : ""}
        </button>

        {matrix_filter_picker_open && (
          <>
            <div className="position-fixed" style={{ inset: 0, zIndex: 1040 }} onClick={() => this.setState({ matrix_filter_picker_open: false, matrix_filter_search: "" })} />
            <div
              className="position-absolute bg-white border rounded-3 shadow p-2 d-flex flex-column"
              style={{ zIndex: 1050, top: "42px", left: 0, width: "280px", maxHeight: "320px" }}
            >
              <input
                type="text"
                className="form-control mb-2 flex-shrink-0"
                placeholder={t("search")}
                value={matrix_filter_search}
                onChange={(e) => this.setState({ matrix_filter_search: e.target.value })}
              />
              <div className="flex-grow-1" style={{ overflowY: "auto", minHeight: 0 }}>
                <label className="d-flex align-items-center gap-2 px-2 py-2 border-bottom fw-bold text-dark mb-1" style={{ cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    className="form-check-input mt-0"
                    checked={(data_technicians || []).length > 0 && (data_technicians || []).every((tc) => matrix_filter_custom.includes(tc.uid))}
                    onChange={() => {
                      const all = (data_technicians || []).map((tc) => tc.uid);
                      const hasAll = all.every((uid) => matrix_filter_custom.includes(uid));
                      this.setState({ matrix_filter_custom: hasAll ? [] : all });
                    }}
                  />
                  {t("select_all")}
                </label>
                {filtered.map((tc) => (
                  <label key={tc.uid} className="d-flex align-items-center gap-2 px-2 py-2 rounded-2 hover-bg-light" style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      className="form-check-input mt-0"
                      checked={matrix_filter_custom.includes(tc.uid)}
                      onChange={() => {
                        const list = this.state.matrix_filter_custom;
                        this.setState({ matrix_filter_custom: list.includes(tc.uid) ? list.filter((v) => v !== tc.uid) : [...list, tc.uid] });
                      }}
                    />
                    <span className="text-14 text-dark">{this.getTechnicianDisplayName(tc)}</span>
                  </label>
                ))}
                {filtered.length === 0 && <div className="text-center text-secondary text-12 py-3">{t("no_data")}</div>}
              </div>
              <div className="d-flex justify-content-end pt-2 mt-1 border-top flex-shrink-0">
                <button
                  type="button"
                  className="btn btn-primary btn-sm px-3 py-1 rounded-3 fw-bold"
                  onClick={() => this.setState({ matrix_filter_mode: "custom", matrix_filter_picker_open: false })}
                >
                  {t("hd_filter_apply")}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }

  changeMonth = (delta) => {
    let { year, month } = this.state;
    month += delta;
    if (month < 1) {
      month = 12;
      year -= 1;
    } else if (month > 12) {
      month = 1;
      year += 1;
    }
    this.setState({ year, month }, () => this.Get());
  };

  goToday = () => {
    const now = new Date();
    this.setState({ year: now.getFullYear(), month: now.getMonth() + 1 }, () => this.Get());
  };

  // ---------- create / update / delete (วันหยุด) ----------
  CreateUpdate = async () => {
    const { uid, scope, technician_uid, holiday_date, holiday_end_date, name, holiday_type, holiday_type_id, note } = this.state;

    if (!holiday_date) {
      alert("", "warning", t("warning"), t("hd_verify_date"));
      return;
    }
    if (scope === "technician" && !technician_uid) {
      alert("", "warning", t("warning"), t("hd_verify_technician"));
      return;
    }
    if (!uid && holiday_end_date && holiday_end_date < holiday_date) {
      alert("", "warning", t("warning"), t("hd_verify_end_date"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);
      const base = {
        company_id: company?.id || "",
        technician_uid: scope === "technician" ? technician_uid : "",
        name: name.trim(),
        holiday_type,
        holiday_type_id: holiday_type_id || "",
        note: note.trim(),
      };

      const result = !uid
        ? await POST("admin/holidays", { ...base, dates: expandRange(holiday_date, holiday_end_date) })
        : await PUT("admin/holidays/" + uid, { ...base, holiday_date });

      if (result?.status === true) {
        const created = result?.data?.created;
        const skipped = result?.data?.skipped;
        const detail = !uid && skipped > 0
          ? t("hd_created_skipped").replace("{created}", created).replace("{skipped}", skipped)
          : t("save_success");
        alert("#", "success", t("success"), detail);
        this.setState({ modal_create: false, modal_update: false });
        this.Get();
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  Delete = async (item) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      const result = await DELETE("admin/holidays/" + item.uid, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.setState({ modal_create: false, modal_update: false });
        this.Get();
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  // ---------- modal (วันหยุด) ----------
  // รายการ master "ประเภทวันหยุด" ตามขอบเขต (company/technician)
  holidayTypeListFor = (scope) => (scope === "technician" ? this.state.data_holiday_types_employee : this.state.data_holiday_types_company) || [];

  // เลียนแบบ native <select> ที่เลือกตัวเลือกแรกให้อัตโนมัติ (ใช้ตอนเปิด modal เพิ่มใหม่ / สลับขอบเขต)
  defaultHolidayTypeId = (scope) => {
    const list = this.holidayTypeListFor(scope);
    const active = list.find((v) => v.is_active !== false) || list[0];
    return active?.uid || "";
  };

  openCreate = (holiday_date = "", technician_uid = "") => {
    const scope = technician_uid ? "technician" : "company";
    this.setState({
      modal_create: true,
      modal_update: false,
      uid: "",
      scope,
      technician_uid: technician_uid || "",
      holiday_date: holiday_date || "",
      holiday_end_date: "",
      name: "",
      holiday_type: scope === "technician" ? "personal" : "company",
      holiday_type_id: this.defaultHolidayTypeId(scope),
      note: "",
    });
  };

  openEdit = (item) => {
    const scope = item.scope === "technician" ? "technician" : "company";
    this.setState({
      modal_create: false,
      modal_update: true,
      uid: item.uid,
      scope,
      technician_uid: item.technician?.uid || "",
      holiday_date: item.holiday_date || "",
      holiday_end_date: "",
      name: item.name || "",
      holiday_type: item.holiday_type || "company",
      holiday_type_id: item.holiday_type_master?.uid || "",
      note: item.note || "",
    });
  };

  openEditByUid = async (uid) => {
    loading(true);
    const result = await GET("admin/holidays", { uid });
    loading(false);
    if (result?.status && result.data) this.openEdit(result.data);
  };

  // ---------- "+ เพิ่มกิจกรรม" ----------
  openActivityCreate = (date = "", technician_uid = "") =>
    this.setState({
      activity_modal_open: true,
      activity_modal_activity: null,
      activity_modal_date: date || "",
      activity_modal_technician_uid: technician_uid || "",
    });

  openActivityEdit = (activity) =>
    this.setState({ activity_modal_open: true, activity_modal_activity: activity });

  closeActivityModal = () => this.setState({ activity_modal_open: false });

  // กิจกรรมที่คาบเกี่ยววันที่ระบุ (กรองตามช่างที่เลือกในตัวกรองถ้ามี)
  activitiesForDate = (dateStr, technicianUid) => {
    const list = (this.state.data_activities || []).filter((a) => a.start_date <= dateStr && a.end_date >= dateStr);
    return technicianUid ? list.filter((a) => (a.technicians || []).some((tc) => tc.uid === technicianUid)) : list;
  };

  activitySummary = (activity) => {
    const techs = (activity.technicians || []).map((tc) => tc.nickname || tc.name || tc.technician_code).filter(Boolean);
    const MAX_TECHS = 2;
    const techLabel = techs.length > MAX_TECHS
      ? `${techs.slice(0, MAX_TECHS).join(", ")} ${t("act_tech_more").replace("{n}", techs.length - MAX_TECHS)}`
      : techs.join(", ");
    // backend ส่งเวลาเป็น "HH:mm:ss" - แสดงแค่ชั่วโมงกับนาที
    const clock = (v) => {
      const m = /^(\d{1,2}):(\d{2})/.exec(String(v || "").trim());
      return m ? `${m[1].padStart(2, "0")}:${m[2]}` : "";
    };
    const start = clock(activity.time_start);
    const end = clock(activity.time_end);
    const time = start ? (end ? `${start}–${end}` : start) : "";
    return [time, activity.objective?.name, techLabel].filter(Boolean).join(" · ");
  };

  // ข้อความเต็มของ tag วันหยุดบริษัท (คลิกดูตาม prototype_calendar.html) เช่น "วันหยุดนักขัตฤกษ์ · วันสงกรานต์"
  companyHolidayToast = (h) => {
    const type = h.recurring ? t("hd_recurring") : this.typeDisplay(h);
    return [type, h.name].filter(Boolean).join(" · ");
  };

  // ข้อความเต็มของ tag วันหยุดช่าง เช่น "ช่างโย · ลาป่วย · ไม่สบาย"
  technicianHolidayToast = (h) => {
    const person = h.technician?.nickname || h.technician?.name || h.technician?.technician_code || "-";
    const type = h.recurring ? t("hd_recurring") : this.typeDisplay(h);
    return [person, type, h.name || h.note].filter(Boolean).join(" · ");
  };

  // toast ข้อความเต็มด้านล่างจอ (ใช้ตอนคลิก tag ในปฏิทิน เพื่ออ่านข้อความที่ถูกตัดด้วย ... ให้ครบ) ตาม prototype_calendar.html
  showToast = (message) => {
    clearTimeout(this.toastTimer);
    this.setState({ toast_message: message });
    this.toastTimer = setTimeout(() => this.setState({ toast_message: "" }), 1800);
  };

  componentWillUnmount() {
    clearTimeout(this.toastTimer);
  }

  // ---------- helpers ----------
  visibleTechnicians = () => {
    const { effective, view, filter_technician, matrix_filter_mode, matrix_filter_custom, data_technicians_mine } = this.state;
    const rows = effective?.technicians || [];
    if (view === "matrix") {
      if (matrix_filter_mode === "custom") return rows.filter((r) => matrix_filter_custom.includes(r.technician.uid));
      if (matrix_filter_mode === "mine") {
        const mineUids = new Set((data_technicians_mine || []).map((tc) => tc.uid));
        return rows.filter((r) => mineUids.has(r.technician.uid));
      }
      return rows;
    }
    return filter_technician ? rows.filter((r) => r.technician.uid === filter_technician) : rows;
  };

  // วันหยุดของช่าง (เฉพาะของตัวเอง ไม่รวมที่รับมาจากบริษัท) แยกตามวัน ตามตัวกรองช่างที่เลือก
  technicianHolidaysByDate = () => {
    const map = {};
    this.visibleTechnicians().forEach((row) => {
      (row.holidays || []).forEach((h) => {
        (map[h.date] ||= []).push({ ...h, technician: row.technician });
      });
    });
    return map;
  };

  companyHolidayMap = () => {
    const map = {};
    (this.state.effective?.company?.holidays || []).forEach((h) => (map[h.date] = h));
    return map;
  };

  typeLabel = (type) => (HOLIDAY_TYPES.includes(type) ? t(`hd_type_${type}`) : type || "-");

  // ประเภทวันหยุดที่แสดงผล: ใช้ master ที่ผู้ใช้ตั้งเองก่อน ถ้าไม่มี (ข้อมูลเก่า) ใช้ enum เดิมแทน
  typeDisplay = (item) => item?.holiday_type_master?.name || this.typeLabel(item?.holiday_type);

  monthTitle = () => {
    const { year, month } = this.state;
    return format_date(new Date(year, month - 1, 1), "mmmm yyyy", currentLang());
  };

  // ---------- render: header / KPI ----------
  renderKpis() {
    const { effective } = this.state;
    const companyHolidays = effective?.company?.holidays || [];
    const technicians = effective?.technicians || [];
    const techHolidayCount = technicians.reduce((sum, r) => sum + (r.holidays || []).length, 0);
    const techWithHoliday = technicians.filter((r) => (r.holidays || []).length > 0).length;

    const cards = [
      { label: t("hd_kpi_company_month"), value: companyHolidays.length, color: "hd-text-company", icon: "" },
      { label: t("hd_kpi_tech_month"), value: techHolidayCount, color: "text-danger", icon: "" },
      { label: t("hd_kpi_tech_count"), value: `${techWithHoliday}/${technicians.length}`, color: "text-danger", icon: "" },
    ];

    return (
      <div className="row g-3 mb-3">
        {cards.map((card, i) => (
          <div className="col-6 col-lg-4" key={i}>
            <div className="card border rounded-4 shadow-sm h-100">
              <div className="card-body d-flex align-items-center gap-3 py-3">
                <span className={`icon text-20 ${card.color}`}>{card.icon}</span>
                <div>
                  <div className="text-secondary text-12">{card.label}</div>
                  <div className={`fw-bold text-18 ${card.color}`}>{card.value}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderMonthNav() {
    return (
      <div className="d-flex align-items-center gap-2">
        <button className="btn btn-white border rounded-3 px-3 py-2" onClick={() => this.changeMonth(-1)} title={t("previous")}>
          <span className="icon">{""}</span>
        </button>
        <div className="fw-bold text-16 text-dark text-center" style={{ minWidth: "170px" }}>{this.monthTitle()}</div>
        <button className="btn btn-white border rounded-3 px-3 py-2" onClick={() => this.changeMonth(1)} title={t("next")}>
          <span className="icon">{""}</span>
        </button>
        <button className="btn btn-white border rounded-3 px-3 py-2 fw-bold" onClick={this.goToday}>{t("today")}</button>
      </div>
    );
  }

  // สีของวันหยุดตัดสินจาก "ขอบเขต" อย่างเดียว: ทั้งบริษัท = เทา / รายช่าง = แดง / กิจกรรม = ทีล
  // ไม่แยกสีตาม recurring (วันหยุดประจำสัปดาห์) อีกแล้ว - เดิมใช้เหลือง/ส้มซึ่งไม่มีในคำอธิบายสี ผู้ใช้อ่านไม่ออกว่าคืออะไร
  // ยังบอกได้ว่าเป็นวันหยุดประจำผ่านข้อความ/tooltip และยังกดแก้รายตัวไม่ได้เหมือนเดิม (ต้องไปแก้ที่ตั้งค่าระบบ)
  renderLegend() {
    const item = (cls, label) => (
      <span className="d-flex align-items-center gap-1 text-12 text-secondary" key={label}>
        <span className={`d-inline-block rounded-1 ${cls}`} style={{ width: 14, height: 14 }} /> {label}
      </span>
    );
    return (
      <div className="d-flex flex-wrap gap-3">
        {item("hd-bg-company-soft", t("hd_company_holiday"))}
        {item("hd-bg-technician-soft", t("hd_technician_holiday"))}
        {item("hd-bg-plan", t("activity_legend"))}
      </div>
    );
  }

  // ---------- render: ปฏิทิน ----------
  renderCalendar() {
    const { year, month, filter_technician } = this.state;
    const total = daysInMonth(year, month);
    const firstWeekday = new Date(year, month - 1, 1).getDay();
    const companyMap = this.companyHolidayMap();
    const techByDate = this.technicianHolidaysByDate();
    const today = todayStr();

    const cells = [];
    for (let i = 0; i < firstWeekday; i++) cells.push(null);
    for (let d = 1; d <= total; d++) cells.push(d);
    while (cells.length % 7 !== 0) cells.push(null);

    return (
      <div className="bg-white rounded-4 shadow-sm p-3">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
          {this.renderMonthNav()}
          <div className="d-flex flex-wrap align-items-center gap-3">
            {this.renderTechnicianFilter()}
            {this.renderLegend()}
          </div>
        </div>

        <div className="table-responsive">
          <div style={{ minWidth: "840px" }}>
            <div className="d-grid" style={{ gridTemplateColumns: "repeat(7, 1fr)", gap: "6px" }}>
              {WEEKDAY_KEYS.map((key, i) => (
                <div key={key} className={`text-center fw-bold text-12 py-1 ${i === 0 || i === 6 ? "text-danger" : "text-secondary"}`}>
                  {t(key)}
                </div>
              ))}
              {cells.map((day, idx) => {
                if (!day) return <div key={idx} className="rounded-3" style={{ height: CAL_CELL_HEIGHT, backgroundColor: "#F8FAFC" }} />;
                const dateStr = toDateStr(year, month, day);
                const companyHoliday = companyMap[dateStr];
                const techList = techByDate[dateStr] || [];
                const activityList = this.activitiesForDate(dateStr, filter_technician);
                const isToday = dateStr === today;

                // รวมวันหยุดช่าง + กิจกรรม เข้าด้วยกัน จำกัดจำนวนบรรทัดที่โชว์เพราะช่องขนาดคงที่
                const extraItems = [
                  ...activityList.map((a) => ({ kind: "plan", key: `p-${a.uid}`, activity: a })),
                  ...techList.map((h) => ({ kind: "tech", key: `h-${h.uid}`, holiday: h })),
                ];
                const shown = extraItems.slice(0, MAX_CAL_EXTRA_ITEMS - (companyHoliday ? 1 : 0));
                // จำนวนรายการทั้งหมดของวันนี้ (รวมวันหยุดบริษัท) - ใช้เปิดกล่องรายการของวันได้เสมอ ไม่ใช่แค่ตอน overflow
                const totalCount = extraItems.length + (companyHoliday ? 1 : 0);

                return (
                  <div
                    key={idx}
                    className={`hd-cal-day rounded-3 border p-2 ${companyHoliday ? "hd-bg-company-light hd-border-company" : "bg-white"}`}
                    style={{ height: CAL_CELL_HEIGHT, overflow: "hidden" }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <span className={`text-14 fw-bold ${isToday ? "bg-dark text-white rounded-circle px-2" : "text-dark"}`}>{day}</span>
                      <div className="d-flex align-items-center gap-1">
                        {can("activity.create") && (
                          <button
                            type="button"
                            className="hd-cal-add hd-cal-add-plan activity.create"
                            title={t("act_add")}
                            onClick={() => this.openActivityCreate(dateStr, filter_technician)}
                          >
                            +
                          </button>
                        )}
                        {can("holiday.create") && (
                          <button
                            type="button"
                            className="hd-cal-add holiday.create"
                            title={t("hd_add")}
                            onClick={() => this.openCreate(dateStr, filter_technician)}
                          >
                            +
                          </button>
                        )}
                      </div>
                    </div>
                    {companyHoliday && (
                      <div
                        className={"hd-cal-chip text-12 fw-bold text-white rounded-2 px-2 py-1 mb-1 text-truncate hd-bg-company"}
                        title={this.companyHolidayToast(companyHoliday)}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (companyHoliday.recurring) {
                            this.showToast(this.companyHolidayToast(companyHoliday));
                            return;
                          }
                          this.openEditByUid(companyHoliday.uid);
                        }}
                      >
                        <span className="icon me-1">{""}</span>
                        {this.companyHolidayToast(companyHoliday)}
                      </div>
                    )}
                    {shown.map((item) =>
                      item.kind === "plan" ? (
                        <div
                          key={item.key}
                          className="hd-cal-chip hd-bg-plan text-12 rounded-2 px-2 py-1 mb-1 text-truncate"
                          title={this.activitySummary(item.activity)}
                          onClick={(e) => { e.stopPropagation(); this.openActivityEdit(item.activity); }}
                        >
                          {this.activitySummary(item.activity)}
                        </div>
                      ) : (
                        <div
                          key={item.key}
                          className={"hd-cal-chip text-12 rounded-2 px-2 py-1 mb-1 text-truncate bg-danger-subtle text-danger"}
                          title={this.technicianHolidayToast(item.holiday)}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (item.holiday.recurring) {
                              this.showToast(this.technicianHolidayToast(item.holiday));
                              return;
                            }
                            this.openEditByUid(item.holiday.uid);
                          }}
                        >
                          {this.technicianHolidayToast(item.holiday)}
                        </div>
                      ),
                    )}
                    {totalCount > MAX_CAL_EXTRA_ITEMS && (
                      <button
                        type="button"
                        className="hd-cal-more text-12 fw-bold"
                        title={t("hd_view_all_day")}
                        onClick={() => this.setState({ modal_day: true, day_date: dateStr })}
                      >
                        {t("hd_view_all_count").replace("{n}", totalCount)}
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ---------- render: modal รายละเอียดทั้งวัน ----------
  renderDayModal() {
    const { modal_day, day_date, filter_technician } = this.state;
    if (!day_date) return null;
    const companyHoliday = this.companyHolidayMap()[day_date];
    const techList = this.technicianHolidaysByDate()[day_date] || [];
    const activityList = this.activitiesForDate(day_date, filter_technician);
    const lang = currentLang();
    const weekday = t(WEEKDAY_KEYS[new Date(`${day_date}T00:00:00`).getDay()]);

    const initials = (technician) => (technician.nickname || technician.name || "?").trim().charAt(0);

    return (
      <Modal
        show={modal_day}
        onHide={() => this.setState({ modal_day: false })}
        centered
        contentClassName="border-0 rounded-4 shadow-lg"
      >
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          <div>
            <h5 className="fw-bold mb-0 text-dark">{format_date(day_date, "dd mmmm yyyy", lang)}</h5>
            <div className="text-secondary text-12">{weekday} · {t("hd_day_summary").replace("{n}", techList.length + (companyHoliday ? 1 : 0))}</div>
          </div>
        </Modal.Header>
        <Modal.Body className="p-4 bg-white" style={{ maxHeight: "60vh", overflowY: "auto" }}>
          {companyHoliday && (
            <div
              className={"hd-day-row d-flex align-items-center gap-3 rounded-3 p-3 mb-3 border hd-bg-company-light hd-border-company"}
              onClick={() => {
                if (companyHoliday.recurring) return;
                this.setState({ modal_day: false });
                this.openEditByUid(companyHoliday.uid);
              }}
            >
              <span className={"icon text-20 hd-text-company"}>{""}</span>
              <div className="flex-grow-1">
                <div className="fw-bold text-dark text-14">{companyHoliday.name || this.typeDisplay(companyHoliday)}</div>
                <div className="text-secondary text-12">
                  {t("hd_scope_company")} · {companyHoliday.recurring ? t("hd_recurring") : this.typeDisplay(companyHoliday)}
                  {companyHoliday.note ? ` · ${companyHoliday.note}` : ""}
                </div>
              </div>
              {!companyHoliday.recurring && <span className="icon text-primary">{""}</span>}
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="fw-bold text-dark text-14">{t("hd_technician_holiday")}</div>
            <span className="badge rounded-pill bg-danger-subtle text-danger">{techList.length}</span>
          </div>
          {techList.length === 0 ? (
            <div className="text-center text-secondary py-4 text-14">{t("no_data")}</div>
          ) : (
            <div className="d-flex flex-column gap-2">
              {techList.map((h, i) => (
                <div
                  key={i}
                  className="hd-day-row d-flex align-items-center gap-3 rounded-3 border p-2 pe-3 bg-white"
                  onClick={() => {
                    if (h.recurring) return;
                    this.setState({ modal_day: false });
                    this.openEditByUid(h.uid);
                  }}
                >
                  {h.technician.image ? (
                    <img src={h.technician.image} alt="" className="rounded-circle" style={{ width: 40, height: 40, objectFit: "cover" }} />
                  ) : (
                    <div
                      className={"rounded-circle d-flex align-items-center justify-content-center fw-bold bg-danger-subtle text-danger"}
                      style={{ width: 40, height: 40 }}
                    >
                      {initials(h.technician)}
                    </div>
                  )}
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="fw-bold text-dark text-14 text-truncate">
                      {h.technician.name || "-"}
                      {h.technician.nickname ? <span className="text-secondary fw-normal"> ({h.technician.nickname})</span> : null}
                    </div>
                    <div className="text-secondary text-12 text-truncate">
                      {[h.technician.technician_code, h.name || (h.recurring ? t("hd_recurring") : this.typeDisplay(h)), h.note].filter(Boolean).join(" · ")}
                    </div>
                  </div>
                  <span className={"badge rounded-pill bg-danger-subtle text-danger"}>
                    {h.recurring ? t("hd_recurring") : this.typeDisplay(h)}
                  </span>
                  {!h.recurring && <span className="icon text-primary">{""}</span>}
                </div>
              ))}
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mb-2 mt-4">
            <div className="fw-bold text-dark text-14">{t("activity_legend")}</div>
            <span className="badge rounded-pill hd-bg-plan">{activityList.length}</span>
          </div>
          {activityList.length === 0 ? (
            <div className="text-center text-secondary py-4 text-14">{t("no_data")}</div>
          ) : (
            <div className="d-flex flex-column gap-2">
              {activityList.map((a) => (
                <div
                  key={a.uid}
                  className="hd-day-row d-flex align-items-center gap-3 rounded-3 border p-2 pe-3 bg-white"
                  onClick={() => {
                    this.setState({ modal_day: false });
                    this.openActivityEdit(a);
                  }}
                >
                  <div className="rounded-circle d-flex align-items-center justify-content-center fw-bold hd-bg-plan" style={{ width: 40, height: 40 }}>
                    <span className="icon">{""}</span>
                  </div>
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="fw-bold text-dark text-14 text-truncate">{a.objective?.name || "-"}</div>
                    <div className="text-secondary text-12 text-truncate">{this.activitySummary(a)}</div>
                  </div>
                  <span className="icon text-primary">{""}</span>
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-between gap-2">
          <button
            className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
            onClick={() => this.setState({ modal_day: false })}
          >
            {t("close")}
          </button>
          <div className="d-flex gap-2">
            {can("activity.create") && (
              <button
                className="btn px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm hd-bg-plan-solid activity.create"
                onClick={() => {
                  this.setState({ modal_day: false });
                  this.openActivityCreate(day_date, filter_technician);
                }}
              >
                <span className="me-2 text-16">+</span> {t("act_add")}
              </button>
            )}
            {can("holiday.create") && (
              <button
                className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm holiday.create"
                style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                onClick={() => {
                  this.setState({ modal_day: false });
                  this.openCreate(day_date, filter_technician);
                }}
              >
                <span className="me-2 text-16">+</span> {t("hd_add")}
              </button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  // ติ๊กถูกในช่องตารางรายช่าง - 1 รายการ = ติ๊กเดียวเต็มช่อง, หลายรายการ = ติ๊กเล็กลงเรียงไม่ให้ล้นช่อง (ช่องกว้าง 30px)
  renderMatrixMarks = (marks) => {
    if (marks.length === 0) return null;
    const size = marks.length === 1 ? 22 : marks.length === 2 ? 15 : marks.length <= 4 ? 12 : 9;
    const iconCls = marks.length === 1 ? "text-12" : marks.length === 2 ? "text-10" : "text-8";
    return (
      <div className="d-flex flex-wrap align-items-center justify-content-center gap-1">
        {marks.map((m) => (
          <span
            key={m.key}
            className={`d-flex align-items-center justify-content-center rounded-1 ${m.cls}`}
            style={{ width: size, height: size, lineHeight: 1, flexShrink: 0 }}
          >
            <span className={`icon ${iconCls}`}>{""}</span>
          </span>
        ))}
      </div>
    );
  };

  // ---------- render: ตารางรายช่าง ----------
  renderMatrix() {
    const { year, month, effective, matrix_filter_mode } = this.state;
    const total = daysInMonth(year, month);
    const days = Array.from({ length: total }, (_, i) => i + 1);
    const companyMap = this.companyHolidayMap();
    const technicians = this.visibleTechnicians();
    const today = todayStr();

    const cellStyle = { width: 30, minWidth: 30, height: 34, padding: 0 };

    return (
      <div className="bg-white rounded-4 shadow-sm p-3">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-2">
          {this.renderMonthNav()}
          <div className="d-flex flex-wrap align-items-center gap-3">
            {this.renderMatrixFilter()}
            {this.renderLegend()}
          </div>
        </div>
        <div className="text-secondary text-12 mb-3">{t("hd_matrix_hint")}</div>

        <div className="table-responsive">
          <table className="table table-bordered align-middle mb-0 text-center" style={{ minWidth: `${220 + total * 30}px` }}>
            <thead>
              <tr className="text-12">
                <th className="text-start bg-light" style={{ minWidth: 200, position: "sticky", left: 0, zIndex: 1 }}>{t("technician")}</th>
                {days.map((d) => {
                  const dateStr = toDateStr(year, month, d);
                  const wd = new Date(year, month - 1, d).getDay();
                  const isWeekend = wd === 0 || wd === 6;
                  return (
                    <th key={d} style={cellStyle} className={`${dateStr === today ? "bg-dark text-white" : isWeekend ? "bg-light text-danger" : "bg-light text-secondary"}`}>
                      <div className="text-12 lh-1">{t(WEEKDAY_KEYS[wd])}</div>
                      <div className="fw-bold">{d}</div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {/* แถวบริษัท */}
              <tr>
                <td className="text-start fw-bold hd-text-company bg-white" style={{ position: "sticky", left: 0, zIndex: 1 }}>
                  <span className="icon me-2">{""}</span>{t("hd_scope_company")}
                </td>
                {days.map((d) => {
                  const dateStr = toDateStr(year, month, d);
                  const h = companyMap[dateStr];
                  return (
                    <td
                      key={d}
                      style={cellStyle}
                      className={`pointer ${h ? "hd-bg-company-light" : ""}`}
                      title={h ? (h.name || (h.recurring ? t("hd_recurring") : this.typeDisplay(h))) : t("hd_add")}
                      onClick={() => {
                        if (!h) this.openCreate(dateStr, "");
                        else if (!h.recurring) this.openEditByUid(h.uid);
                      }}
                    >
                      {h && this.renderMatrixMarks([{ key: `c-${h.uid || dateStr}`, cls: "hd-bg-company-soft" }])}
                    </td>
                  );
                })}
              </tr>

              {technicians.length === 0 ? (
                <tr>
                  <td colSpan={total + 1} className="text-secondary py-4">
                    {matrix_filter_mode === "mine" ? t("hd_filter_mine_empty") : t("no_data")}
                  </td>
                </tr>
              ) : (
                technicians.map((row) => {
                  const own = {};
                  (row.holidays || []).forEach((h) => (own[h.date] = h));
                  return (
                    <tr key={row.technician.uid}>
                      <td className="text-start bg-white" style={{ position: "sticky", left: 0, zIndex: 1 }}>
                        <div className="text-14 fw-bold text-dark text-truncate" style={{ maxWidth: 200 }}>{row.technician.name || "-"}</div>
                        <div className="text-12 text-secondary">{[row.technician.technician_code, row.technician.nickname].filter(Boolean).join(" · ")}</div>
                      </td>
                      {days.map((d) => {
                        const dateStr = toDateStr(year, month, d);
                        const h = own[dateStr];
                        const cellActivities = this.activitiesForDate(dateStr, row.technician.uid);
                        const hasActivity = !h && cellActivities.length > 0;
                        const inherited = !h && !hasActivity && companyMap[dateStr];
                        // จำนวนรายการจริงในช่องนี้ (วันหยุดช่าง + กิจกรรม) - มากกว่า 1 ให้เปิดรายการของวันให้เลือกเอง
                        const cellCount = (h ? 1 : 0) + cellActivities.length;
                        // ช่องที่สืบทอดวันหยุดบริษัท (ไม่มีรายการของตัวเอง) คงพื้นหลังอ่อนเดิม ไม่ติ๊กถูก
                        const cls = cellCount === 0 && inherited ? "hd-bg-company-light" : "";
                        // ติ๊กถูกแยกสีต่อรายการ: วันหยุดช่าง (แดงเสมอ ไม่แยกตามวันหยุดประจำ) + กิจกรรม (ทีล)
                        const marks = [
                          ...(h ? [{ key: `h-${h.uid}`, cls: "hd-bg-technician-soft" }] : []),
                          ...cellActivities.map((a) => ({ key: `a-${a.uid}`, cls: "hd-bg-plan" })),
                        ];
                        const title = h
                          ? (h.name || (h.recurring ? t("hd_recurring") : this.typeDisplay(h)))
                          : hasActivity ? t("activity_legend") : inherited ? t("hd_inherited") : t("hd_add");
                        return (
                          <td
                            key={d}
                            style={cellStyle}
                            className={`pointer ${cls}`}
                            title={title}
                            onClick={() => {
                              if (cellCount === 0) {
                                this.openCreate(dateStr, row.technician.uid);
                                return;
                              }
                              if (cellCount > 1) {
                                this.setState({ day_date: dateStr, modal_day: true });
                                return;
                              }
                              if (h) {
                                if (!h.recurring) this.openEditByUid(h.uid);
                                return;
                              }
                              this.openActivityEdit(cellActivities[0]);
                            }}
                          >
                            {this.renderMatrixMarks(marks)}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        {!effective && <div className="text-center text-secondary py-4">{t("no_data")}</div>}
      </div>
    );
  }

  // ---------- render: modal (วันหยุด) ----------
  renderModal() {
    const { modal_create, modal_update, uid, scope, technician_uid, holiday_date, holiday_end_date, name, holiday_type, holiday_type_id, note } = this.state;

    return (
      <Modal
        show={modal_create || modal_update}
        onHide={() => this.setState({ modal_create: false, modal_update: false })}
        centered
        contentClassName="border-0 rounded-4 shadow-lg"
      >
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit") : t("hd_add")}</h5>
        </Modal.Header>
        <Modal.Body className="p-4 bg-white">
          <div className="row g-3">
            <div className="col-12">
              <label className="form-label text-14 text-dark mb-2">{t("hd_scope")}</label>
              <div className="d-flex gap-4">
                {["company", "technician"].map((value) => (
                  <div className="form-check d-flex align-items-center gap-2" key={value}>
                    <input
                      className="form-check-input mt-0 pointer"
                      type="radio"
                      name="holidayScope"
                      id={`holidayScope-${value}`}
                      checked={scope === value}
                      onChange={() => {
                        const nextHolidayType = value === "technician" ? "personal" : (holiday_type === "personal" ? "company" : holiday_type);
                        this.setState({
                          scope: value,
                          holiday_type: nextHolidayType,
                          holiday_type_id: this.defaultHolidayTypeId(value),
                        });
                      }}
                    />
                    <label className="form-check-label text-dark text-14 pointer" htmlFor={`holidayScope-${value}`}>{t(`hd_scope_${value}`)}</label>
                  </div>
                ))}
              </div>
            </div>

            {/* แสดงช่องช่างเสมอ (ปิดใช้เมื่อเลือกทั้งบริษัท) เพื่อให้ modal สูงเท่ากันตอนสลับขอบเขต */}
            <div className="col-12">
              <label className={`form-label text-14 mb-2 ${scope === "technician" ? "text-dark" : "text-secondary"}`}>
                {t("technician")} {scope === "technician" && <span className="text-danger">*</span>}
              </label>
              <Select
                className="form-control"
                placeholder={scope === "technician" ? t("select_technician") : t("hd_scope_company")}
                options={this.technicianOptions(technician_uid)}
                value={scope === "technician" ? technician_uid : ""}
                disabled={scope !== "technician"}
                onChange={(value) => this.setState({ technician_uid: value })}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label text-14 text-dark mb-2">
                {modal_update ? t("date") : t("start_date")} <span className="text-danger">*</span>
              </label>
              <DatePicker
                type={currentLang()}
                className="form-control"
                value={holiday_date}
                onChange={(value) => this.setState({ holiday_date: value })}
              />
            </div>
            {!modal_update && (
              <div className="col-md-6">
                <label className="form-label text-14 text-dark mb-2">{t("hd_to_date")}</label>
                <DatePicker
                  type={currentLang()}
                  className="form-control"
                  value={holiday_end_date}
                  min={holiday_date || undefined}
                  onChange={(value) => this.setState({ holiday_end_date: value })}
                />
                <div className="text-secondary text-12 mt-1">{t("hd_range_hint")}</div>
              </div>
            )}

            <div className="col-md-6">
              <label className="form-label text-14 text-dark mb-2">{t("hd_name")}</label>
              <input
                type="text"
                className="form-control py-2"
                placeholder={t("hd_name_placeholder")}
                value={name}
                onChange={(e) => this.setState({ name: e.target.value })}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label text-14 text-dark mb-2">{t("type")}</label>
              <Select sort={false}
                className="form-control py-1 d-flex align-items-center"
                options={activeOptions(
                  this.holidayTypeListFor(scope).map((v) => ({ value: v.uid, label: v.name, is_active: v.is_active })),
                  holiday_type_id,
                )}
                value={holiday_type_id}
                onChange={(value) => this.setState({ holiday_type_id: value })}
              />
            </div>
            <div className="col-12">
              <label className="form-label text-14 text-dark mb-2">{t("note")}</label>
              <textarea
                className="form-control py-2"
                rows={2}
                value={note}
                onChange={(e) => this.setState({ note: e.target.value })}
              />
            </div>

            <div className="col-12">
              <div className="text-secondary text-12"><span className="icon me-1">{""}</span>{t("hd_no_lock_hint")}</div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-between gap-2">
          <div>
            {modal_update && can("holiday.delete") && (
              <button
                className="btn btn-white border border-danger text-danger px-4 py-2 rounded-3 fw-bold holiday.delete"
                onClick={() => this.Delete({ uid })}
              >
                <span className="icon me-2">{""}</span> {t("delete")}
              </button>
            )}
          </div>
          <div className="d-flex gap-2">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ modal_create: false, modal_update: false })}
            >
              {t("cancel")}
            </button>
            {(modal_create || can("holiday.update")) && (
              <button
                className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                onClick={this.CreateUpdate}
              >
                <span className="icon me-2">{""}</span> {t("save")}
              </button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  // ---------- render: modal "+ เพิ่มกิจกรรม" (ใช้ component ร่วมกับหน้าจัดตารางงาน) ----------
  renderActivityModal() {
    const { activity_modal_open, activity_modal_activity, activity_modal_date, activity_modal_technician_uid, data_technicians, data_objectives } = this.state;
    return (
      <ActivityModal
        show={activity_modal_open}
        activity={activity_modal_activity}
        defaultDate={activity_modal_date}
        defaultTechnicianUid={activity_modal_technician_uid}
        technicians={data_technicians}
        objectives={data_objectives}
        onClose={this.closeActivityModal}
        onSaved={this.refreshActivities}
      />
    );
  }

  render() {
    const { view, toast_message } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("calendar_settings")}</h3>
              <div className="text-secondary text-14">{t("hd_desc")}</div>
            </div>
            <div className="d-flex gap-2">
              {can("activity.create") && (
                <button
                  className="btn px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center hd-bg-plan-solid activity.create"
                  onClick={() => this.openActivityCreate()}
                >
                  <span className="me-2 text-16">+</span> {t("act_add")}
                </button>
              )}
              {can("holiday.create") && (
                <button
                  className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center holiday.create"
                  onClick={() => this.openCreate()}
                >
                  <span className="me-2 text-16">+</span> {t("hd_add")}
                </button>
              )}
            </div>
          </div>

          {this.renderKpis()}

          <div className="d-flex flex-wrap gap-2 mb-3">
            {VIEWS.map((v) => (
              <button
                key={v}
                className={`btn rounded-pill px-3 py-2 fw-bold text-14 ${view === v ? "btn-dark" : "btn-white border"}`}
                onClick={() => this.setState({ view: v })}
              >
                {t(`hd_view_${v}`)}
              </button>
            ))}
          </div>

          {view === "calendar" && this.renderCalendar()}
          {view === "matrix" && this.renderMatrix()}
        </div>

        {this.renderModal()}
        {this.renderDayModal()}
        {this.renderActivityModal()}

        {/* toast ข้อความเต็มด้านล่างจอ ตอนคลิก tag ในปฏิทิน (ตาม prototype_calendar.html) */}
        <div className={`hd-toast ${toast_message ? "show" : ""}`}>{toast_message}</div>
      </div>
    );
  }
}
